<template>
  <section class="content">
    <div>
      <div>
        <div class="box-body">
          <v-server-table
            name="demo5"
            :limit="5"
            ref="tripTable"
            url
            :columns="columns"
            :options="options"
            v-on:row-click="edit"
            @loaded="onLoaded"
          >
            <template slot="beforeBody">
              <tr
                v-if="loading"
                class="VueTables__no-results"
                v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]"
              >
                <td class="text-center" colspan="9">
                  <pulse-loader></pulse-loader>
                </td>
              </tr>
            </template>
          </v-server-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import { getTitle } from '../../../mixins/capsMixins';

import moment from 'moment';
export default {
  name: 'demo5',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      tripTable: null,
      columns: [
        'tripCode',
        'routeIdName',
        'driverIdDriverName',
        'deviceIdImei',
        'vehicleIdRegNo',
        'startSiteSiteName',
        'scheduleDate',
      ],
      customFilters: [status == 'Halt'],
      options: {
        highlightMatches: true,
        sortable: [
          'tripCode',
          'routeIdName',
          'driverIdDriverName',
          'deviceIdImei',
          'vehicleIdRegNo',
          'startSiteSiteName',
          'scheduleDate',
        ],
        headings: {
          tripCode: 'Trip Id',
          routeIdName: 'Route',
          driverIdDriverName: 'Driver',
          deviceIdImei: 'Device',
          vehicleIdRegNo: 'Vehicle',
          startSiteSiteName: 'From-To',
          scheduleDate: 'Schedule Date',
        },
        templates: {
          startSiteSiteName(row, query) {
            return `${query.startSiteSiteName} - ${query.endSiteSiteName}`;
          },
          scheduleDate(row, query) {
            console.log('schedule function');
            return moment(`${query.scheduleDate}`).format('DD-MM-YYYY');
          },
          _id(row, query) {
            return `${query._id}`;
          },
        },

        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.status = 'completed';
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$tripDataRepository.list(params).catch(error => {
            console.error('Trip.requestFunction-error:', error);
            this.$snotify.error('Get Trip', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit ||
          this.tripTable.limit > 5
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'TripActivity',
        params: { _id: data.row._id, status: 'Completed' },
        props: data.row,
      });
    },
    onLoaded() {
      this.tripTable = this.$refs.tripTable;
    },
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

#addUser {
  margin-bottom: 10px;
}
.VuePagination {
  text-align: right !important;
}
</style>


// WEBPACK FOOTER //
// CompletedTrip.vue?285a8b3d